<template>
  <div class="recommend ">
    <el-form-item label="推荐商品配置：" class="width100">
      <el-select v-model="form.sysGoodsRecommendList" filterable multiple placeholder="请选择推荐商品">
        <el-option v-for="item in options.sysGoods" :key="item.id" :label="item.codeAndName" :value="item.id"></el-option>
      </el-select>
    </el-form-item>
  </div>
</template>

<script>
import sysGoodsApi from '@/api/sys/sysGoods'
export default {
  props: ['form'],
  data() {
    return {
      options: {
        sysGoods: []
      }
    }
  },
  created() {
    this.getGoods()
  },
  methods: {
    getGoods() {
      sysGoodsApi.getGoodRecomList().then(({ data }) => {
        console.log(data)
        data.forEach(item => {
          item.codeAndName = `${item.goodsCode} ${item.name}`
        });
        this.options.sysGoods = data
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.el-form-item--small.el-form-item.width100 {
  width: 97%;
}
</style>